// DNBEmergencyMedicine.jsx
import { useLocation, useNavigate } from "react-router-dom";
import "./DNBCourses.css";
import Navbar from "../../Navbar/Navbar";
import NavbarLocation from "../../Navbar/NavbarLocation";
import SEO from "../../SEO/SEO";

function DNBEmergencyMedicine() {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname.toLowerCase();

  let locationFilter = null;
  let basePath = "/EmergencyMedicine";
  if (path.includes("ashwinihospitalcuttack")) {
    locationFilter = "Ashwini Hospital";
    basePath = "/AshwiniHospitalCuttack/EmergencyMedicine";
  } else if (path.includes("adityaashwinihospital")) {
    locationFilter = "Aditya Ashwini Hospital";
  } else if (path.includes("ashwinitraumacentre")) {
    locationFilter = "Ashwini Trauma Centre";
  }

  return (
    <>
      {locationFilter ? <NavbarLocation /> : <Navbar />}
      <SEO
        title="DNB Emergency Medicine (Post MBBS) at Ashwini Hospital, Odisha | NBE Accredited"
        description="Join the DNB Emergency Medicine program at Ashwini Hospital, Cuttack, Odisha. Accredited by NBE, this 3-year postgraduate training equips MBBS graduates with skills to manage medical emergencies efficiently. 2 seats available."
        keywords="DNB Emergency Medicine, Emergency Medicine Post MBBS, DNB EM Odisha, Ashwini Hospital Cuttack DNB, NBE Emergency Medicine Training, NEET PG Emergency Medicine, Critical Care Training, DNB Emergency Medicine India, Hospital-based Emergency Medicine Course"
      />

      <div className="dnb dnb-respiratory">
        <button
          className="btn btn-danger position-absolute"
          onClick={() => navigate(basePath)}
        >
          Emergency & Trauma Care
        </button>

        <section className="text-center banner">
          <h1 className="fw-bold">
            <strong>DNB Emergency Medicine</strong> at Ashwini Hospital, Odisha
          </h1>
          <p className="text-danger fs-5">
            <strong>NBE-Accredited Postgraduate Training</strong> in Emergency
            Medicine
            <span className="text-success fw-semibold"> (2 Seats)</span>
          </p>
        </section>

        <section>
          <h2>Program Overview</h2>
          <p>
            The <strong>DNB Emergency Medicine</strong> program at{" "}
            <strong>Ashwini Hospital, Cuttack</strong> is a{" "}
            <strong>3-year residency</strong> designed to produce proficient{" "}
            <strong>emergency physicians</strong> capable of handling{" "}
            <strong>life-threatening situations</strong> with skill and
            confidence. This program is open to <strong>Post MBBS</strong>{" "}
            candidates through <strong>NEET PG</strong> and is recognized by the{" "}
            <strong>National Board of Examinations (NBE)</strong>.
          </p>
          <p>
            Trainees gain expertise in managing{" "}
            <strong>
              trauma, cardiac arrest, poisoning, sepsis, acute respiratory
              distress
            </strong>
            , and more — using{" "}
            <strong>
              advanced life support techniques, emergency procedures, and rapid
              diagnostic decision-making
            </strong>
            .
          </p>
        </section>

        <section className="highlight-box">
          <h2>Why Choose Ashwini Hospital?</h2>
          <ul>
            <li>
              <strong>Leading emergency care center</strong> in Odisha
            </li>
            <li>
              <strong>High volume</strong> of real-world emergency cases
            </li>
            <li>
              <strong>Hands-on training</strong> under senior emergency
              consultants
            </li>
            <li>
              <strong>Simulation-based skill development</strong> & ICU exposure
            </li>
          </ul>
        </section>

        <section>
          <h2>Key Features</h2>
          <ul>
            <li>
              <strong>3-Year DNB Program</strong> for MBBS graduates
            </li>
            <li>
              <strong>Direct emergency department involvement</strong> from Day
              1
            </li>
            <li>
              Exposure to <strong>airway management, ACLS, ATLS</strong>, and{" "}
              <strong>trauma resuscitation</strong>
            </li>
            <li>
              Rotations through{" "}
              <strong>ICU, Anaesthesia, Surgery, and Radiology</strong>
            </li>
            <li>
              Daily{" "}
              <strong>
                clinical rounds, simulation drills, case discussions, and
                academic CMEs
              </strong>
            </li>
          </ul>
        </section>

        <section>
          <h2>Infrastructure Highlights</h2>
          <ul>
            <li>
              <strong>24x7 Emergency Department</strong> with Triage,
              Resuscitation, and Trauma Bays
            </li>
            <li>
              In-house <strong>CT Scan, Radiology, and Pathology Labs</strong>
            </li>
            <li>
              Dedicated <strong>Surgical ICU and Critical Care</strong> Support
            </li>
            <li>
              Fully-equipped{" "}
              <strong>
                Procedure Rooms and Point-of-Care Ultrasound (POCUS)
              </strong>
            </li>
            <li>
              Access to <strong>EMS services</strong> and{" "}
              <strong>Ambulance network</strong>
            </li>
          </ul>
        </section>

        <section>
          <h2>Course Duration</h2>
          <p>
            <strong>3 Years</strong> of full-time{" "}
            <strong>hospital-based residency</strong> with continuous clinical
            supervision and academic mentoring.
          </p>
        </section>

        <section className="apply-box">
          <h2>How to Apply</h2>
          <ul>
            <li>
              <strong>Eligibility:</strong> MBBS degree from an{" "}
              <strong>MCI/NMC-recognized institution</strong> and a{" "}
              <strong>completed 1-year internship</strong>.
            </li>
            <li>
              <strong>Application Process:</strong> Register on the{" "}
              <a
                href="https://nbe.edu.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>NBE website</strong>
              </a>{" "}
              by submitting the online form, documents (degree, ID, internship),
              and application fee.
            </li>
            <li>
              <strong>Entrance:</strong> Admission is based on{" "}
              <strong>NEET PG merit</strong>, followed by centralized counseling
              by <strong>NBEMS</strong>.
            </li>
          </ul>
        </section>

        <section>
          <h2>Career Opportunities</h2>
          <ul>
            <li>
              <strong>Emergency Physician</strong> in hospitals and trauma
              centers
            </li>
            <li>
              Opportunities in{" "}
              <strong>Critical Care, EMS, and Disaster Response</strong>
            </li>
            <li>
              <strong>Teaching roles</strong> in Medical Colleges
            </li>
            <li>
              <strong>Global demand</strong> for Emergency Medicine specialists
            </li>
          </ul>
        </section>

        <section className="contact-box">
          <h2>Admission Helpdesk</h2>
          <p>
            <strong>Ashwini Hospital – Cuttack, Odisha</strong>
          </p>
          <p>
            📧 Email: <strong>academic@ashwinihospital.com</strong>
          </p>
          <p>
            📞 Phone: <strong>+91-XXXXXXXXXX</strong>
          </p>
          <p>
            🌐 Website:{" "}
            <a
              href="https://www.ashwinihospital.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>ashwinihospital.com</strong>
            </a>
          </p>
          <p>
            🔗 NEET PG Info:{" "}
            <a
              href="https://nbe.edu.in"
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>nbe.edu.in</strong>
            </a>
          </p>
        </section>
      </div>
    </>
  );
}

export default DNBEmergencyMedicine;
